import React from 'react';
import {
  Component,
  PuzzleDropDownButton,
  WithTooltip
} from "puzzle";
import { DropDownButtonItem, DropDownButtonItemClickEvent } from "@progress/kendo-react-buttons";
import { PuzzleTooltip as TpTooltip } from "puzzle/components";
import { find } from "lodash";

type LANGUAGE = {
  locale: string,
  value: string
}
type LANGUAGE_DATA = {
  languages: LANGUAGE[]
}
type STATE = {
  currentLocale: string,
  allLanguages: LANGUAGE[]
}

class ChangeLanguage extends Component<{}, STATE> {
  tooltip: any;

  state: STATE = {
    currentLocale: '',
    allLanguages: []
  };

  /**
   * Set current locale
   * @param {String} currentLocale
   */
  setCurrentLocale = (currentLocale: string) => {
    this.setState({ currentLocale });
  }

  /**
   * Sets `languages` to `state`s `allLanguages`.
   *
   * @param {LANGUAGE_DATA} languageData
   * @param {String} currentLocale
   */
  setLanguages = (languageData: LANGUAGE_DATA, currentLocale: string) => {
    this.setState({ allLanguages: languageData.languages, currentLocale });
  };

  /**
   * If different locale is selected, call dispatch to change language
   * @param {DropDownButtonItemClickEvent} event
   */
  switchLanguage = (event: DropDownButtonItemClickEvent) => {
    const { allLanguages, currentLocale } = this.state;
    const selectedLanguage = find(allLanguages, (item) => item.value === event.item.text)?.locale;
    if (selectedLanguage && selectedLanguage !== currentLocale) {
      const languagePreferencesData = { selectedLanguage };
      this.setState({ currentLocale: selectedLanguage });
      this.dispatch('changeLanguageFromHeader', '', { selectedLanguage, languagePreferencesData });
    }
  };

  renderBody() {
    const { allLanguages, currentLocale } = this.state;
    return (
      <>
        <WithTooltip
          context={this}
          title={this.translate('switchLanguageTooltip')}
          htmlTag={'span'}
        >
          <PuzzleDropDownButton
            fillMode={'flat'}
            iconClass="tp-icon tp-language"
            onItemClick={(e: any) => this.switchLanguage(e)}
            title={this.translate('switchLanguageTooltip')}
          >
            {(allLanguages || []).map((item: LANGUAGE, index: number) =>
              <DropDownButtonItem
                selected={currentLocale === item.locale}
                key={index}
                text={item.value}
              />)}
          </PuzzleDropDownButton>
        </WithTooltip>
        <TpTooltip
          anchorElement={'target'}
          ref={(el: any) => this.tooltip = el}
          openDelay={1000}
          position="bottom"
        />
      </>
    );
  }
}

export default ChangeLanguage;
